import { render } from "./KeyValueTable.vue?vue&type=template&id=a483d584"
import script from "./KeyValueTable.vue?vue&type=script&lang=js"
export * from "./KeyValueTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__